module.exports = __webpack_public_path__ + "static/creative-31fe96d76abe82842b8d6fedb4a79bf3.svg";